/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileModel } from '../../models/profile-model';

export interface ProfileSaveProfilePost$Params {
      body?: ProfileModel
}

export function profileSaveProfilePost(http: HttpClient, rootUrl: string, params?: ProfileSaveProfilePost$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<ProfileModel>> {
  const rb = new RequestBuilder(rootUrl, profileSaveProfilePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VitalScoreStrictHttpResponse<ProfileModel>;
    })
  );
}

profileSaveProfilePost.PATH = '/Profile/SaveProfile';
